/* eslint-disable react/display-name */
import React, { useState } from 'react';
import { View } from 'react-native';
import { WindowInformation } from '../services/window-information';
import MyAppText from './MyAppText';
import { translate } from '../services/translate';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import CustomButton from './CustomButton';
import { forceRedirectToLogin } from '../services/navigation-assistant';

const messageConfig = {
    invalidAuth: (params: MessageOptions) => {
        const InvalidAuth = () => {
            const { styles } = useStyles(styleSheet);
            return <View style={styles.container}>
                <MyAppText style={styles.headerText}>
                    {translate('authError')}
                </MyAppText>
                <CustomButton
                    onPress={() => {
                        params.hide();
                        forceRedirectToLogin();
                    }}
                    text='OK'
                    type='secondary'
                    contentContainerStyle={{ width: 120 }}
                />
            </View >;
        };
        return <InvalidAuth />;
    }
};

const styleSheet = createStyleSheet((theme) => ({
    container: {
        backgroundColor: theme.colors.card.background,
        borderColor: theme.colors.card.border,
        padding: 25,
        alignItems: 'center',
        width: 350,
        gap: 20,
        borderRadius: 8,
        borderWidth: 1,
    },
    headerText: {
        fontSize: 16,
        color: theme.colors.neutral['500'],
        fontWeight: '600',
        textAlign: 'center'
    }
}));

interface MessageProps {
    // type: keyof typeof messages;
}

interface MessageOptions extends MessageShowParams {
    hide: () => void;
}

const MessageRoot = React.forwardRef((props: MessageProps, ref) => {

    const [isVisible, setIsVisible] = useState(false);
    const windowInfo = WindowInformation();

    const initialOptions: MessageOptions = {
        type: 'invalidAuth',
        hide: () => setIsVisible(false)
    };

    const [options, setOptions] = React.useState<MessageOptions>(initialOptions);

    const show = React.useCallback(
        (params: MessageShowParams) => {
            setOptions({ ...options, ...params });
            setIsVisible(true);
        },
        []
    );

    React.useImperativeHandle(
        ref,
        React.useCallback(
            () => ({
                show
            }),
            [show]
        )
    );

    if (!isVisible) {
        return <></>;
    }

    return <View style={{
        backgroundColor: '#31313199',
        height: windowInfo.height,
        alignItems: 'center',
        justifyContent: 'center'
    }}>
        {messageConfig[options.type](options)}
    </View>;

});

type MessageRefObj = {
    current: MessageRef | null;
};

let refs: MessageRefObj[] = [];

type MessageRef = {
    show: (params: MessageShowParams) => void;
};

interface MessageShowParams {
    type: keyof typeof messageConfig;
}

function addNewRef(newRef: MessageRef) {
    refs.push({
        current: newRef
    });
}


function removeOldRef(oldRef: MessageRef | null) {
    refs = refs.filter((r) => r.current !== oldRef);
}

export function MyMessage(props: MessageProps) {
    const messageRef = React.useRef<MessageRef>(null);

    const setRef = React.useCallback((ref: MessageRef | null) => {
        if (ref) {
            addNewRef(ref);
        } else {
            removeOldRef(messageRef.current);
        }
    }, []);

    return (
        <MessageRoot ref={setRef} {...props} />
    );
}

function getRef() {
    const reversePriority = [...refs].reverse();
    const activeRef = reversePriority.find((ref) => ref?.current !== null);
    if (!activeRef) {
        return null;
    }
    return activeRef.current;
}


MyMessage.show = (params: MessageShowParams) => {
    getRef()?.show(params);
};
